let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("joJy8"), load("aHE9G"), load("hcY7w")]).then(() => parcelRequire('i6Hw8'));